import * as cx from 'classnames';
import * as React from 'react';
import * as Styles from './SectionHeader.scss';

interface IOwnProps {
  title: string;
  accent?: boolean;
  light?: boolean;
}

const SectionHeader: React.SFC<IOwnProps> = ({ title, accent, light }) => {
  const sectionHeaderClassNames = cx({
    [Styles.header]: true,
    [Styles.accent]: accent,
    [Styles.light]: light,
  });

  return (
    <div className={sectionHeaderClassNames}>
      <span className={Styles.title}>{title}</span>
    </div>
  );
};

export default SectionHeader;
